import React, { useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import useQueryParams from "hooks/useQueryParams";
import { getLicenseXmlById } from "client/api/ServerLicenseApi";
import { PolicyAuthorized } from "components/authorization/PolicyAuthorized";
import { RbacPolicies } from "components/authorization/RbacPolicies";
import { LicenseKeyXmlView } from "areas/licenses/component/LicenseKeyXmlView";
import { CloudLicenseKeyXmlDialog } from "areas/licenses/detail/CloudLicenseKeyXmlDialog";
import { LegacyLicenseKeyXmlDialog } from "areas/licenses/detail/LegacyLicenseKeyXmlDialog";
import useAsyncRequest from "../../../hooks/useAsyncRequest";

interface LicenseKeyViewProps {
  licenseId: string;
}

export function LicenseKeyView({ licenseId }: LicenseKeyViewProps) {
  const { data, loading, error } = useAsyncRequest(getLicenseXmlById, licenseId);
  const [showLegacyXmlDialog, setShowLegacyXmlDialog] = useState<boolean>(false);

  const showCloudXmlDialogParamName = "showCloudXmlDialog";
  const [parameters] = useQueryParams({ paramKeys: [showCloudXmlDialogParamName] });

  const [showCloudXmlDialog, setShowCloudXmlDialog] = useState<boolean>(
    parameters[showCloudXmlDialogParamName] === "true"
  );

  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <Typography variant={"h5"}>License key</Typography>
      </Grid>
      <Grid size={12}>
        <LicenseKeyXmlView loading={loading} licenseXml={data?.licenseXml} error={error} />
        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <PolicyAuthorized policies={RbacPolicies.ServerLicenses.CloudXmlRead}>
            <Button variant="text" size="small" onClick={() => setShowCloudXmlDialog(true)}>
              Show cloud XML
            </Button>
          </PolicyAuthorized>
          <Button variant="text" size="small" onClick={() => setShowLegacyXmlDialog(true)}>
            Show legacy XML
          </Button>
        </Box>
      </Grid>
      <LegacyLicenseKeyXmlDialog
        open={showLegacyXmlDialog}
        serverLicenseId={licenseId}
        onClose={() => setShowLegacyXmlDialog(false)}
      />
      <CloudLicenseKeyXmlDialog
        open={showCloudXmlDialog}
        serverLicenseId={licenseId}
        onClose={() => setShowCloudXmlDialog(false)}
      />
    </Grid>
  );
}
